
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MailSignature',
  
  created(){
    window.location.href = "/mailsignature/ccooobanner-2026-02.png";
  }
});
